import { render } from "./BaseInfiniteGridTable.vue?vue&type=template&id=66aecbdc&scoped=true"
import script from "./BaseInfiniteGridTable.vue?vue&type=script&lang=js"
export * from "./BaseInfiniteGridTable.vue?vue&type=script&lang=js"

import "./BaseInfiniteGridTable.vue?vue&type=style&index=0&id=66aecbdc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66aecbdc"]])

export default __exports__